module.exports = __webpack_public_path__ + "static/transformation-banner-868ddbc727a3ece21b0cca6eb726d638.png";